import { createQueryKeys } from '@lukemorales/query-key-factory';

export const uaeIdentity = createQueryKeys('uaeIdentity', {
  mine: null,
  reviews: (filters: Record<string, string>) => [filters],
  review: (id: string) => [id],
});
